/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/New/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Request/Content/Content/Contract/Content/Preview/Content/Content"
  
}) {
let contentValueData = fromData.useDataValue({ viewPath,
context: 'content',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 data="content"
 value={contentValueData}
 disabled={true}
 toolbar={false}
 menubar={false}
/>
</div>
{children}
</React.Fragment>)
}